import React from 'react';
import { getTotalCost, getTotalBaseAnnualCost } from 'utils/form_validaters/payment_form_helper';
import { FormattedMessage } from 'react-intl';
import PlanCode from 'types/PlanCode';
import PlanTypeType from 'types/PlanTypeType';
import CurrencyCode from 'types/CurrencyCode';

type Coupon = {
  code: string;
  discountedPricePerYear: string;
  discountPercentage: number;
  originalPricePerYear: string;
};

type PaymentFinePrintProps = {
  activePlanType: PlanCode;
  currencyCode: CurrencyCode;
  planTypes: PlanTypeType[];
  verifiedCoupon?: Coupon;
  isCouponApplied: boolean;
};

export default function PaymentFinePrint({ activePlanType, currencyCode, planTypes, verifiedCoupon, isCouponApplied }: PaymentFinePrintProps) {
  const months = planTypes.find(planType => planType.planCode === activePlanType).numberOfMonths;
  const totalCost = getTotalCost(planTypes, activePlanType, verifiedCoupon, currencyCode);
  const baseAnnualCost = getTotalBaseAnnualCost(planTypes, activePlanType, currencyCode);

  if (activePlanType === PlanCode.ThreeYear) {
    return (
      <FormattedMessage defaultMessage="The 3-year subscription is a one time purchase that does not renew. After 36 months, your subscription will expire and you will have the option to re-upgrade." />
    );
  }

  if (activePlanType === PlanCode.SevenDayTrial) {
    // always multiple months here so we don't need singular form
    return (
      <FormattedMessage
        defaultMessage="Note: You will be charged {baseAnnualCost} when your free trial ends and it will automatically renew after {months} months unless you update your renewal settings."
        values={{ baseAnnualCost, months }}
      />
    );
  }

  // TODO: DISCO-547 - We should use a common pattern to handle plurals
  if (isCouponApplied) {
    if (months === '1') {
      return (
        <FormattedMessage
          defaultMessage="Note: you will be charged {cost} today and automatically renew after {months} month at {baseAnnualCost} unless you update your renewal settings."
          values={{ baseAnnualCost, cost: totalCost, months }}
        />
      );
    }
    return (
      <FormattedMessage
        defaultMessage="Note: you will be charged {cost} today and automatically renew after {months} months at {baseAnnualCost} unless you update your renewal settings."
        values={{ baseAnnualCost, cost: totalCost, months }}
      />
    );
  }

  if (months === '1') {
    return (
      <FormattedMessage
        defaultMessage="Note: you will be charged {cost} today and automatically renew after {months} month unless you update your renewal settings."
        values={{ cost: totalCost, months }}
      />
    );
  }
  return (
    <FormattedMessage
      defaultMessage="Note: you will be charged {cost} today and automatically renew after {months} months unless you update your renewal settings."
      values={{ cost: totalCost, months }}
    />
  );
}
